'use strict';

var analyticsHelper = require('app_honda_cars/utils/analyticsHelper');

/**
 * Create an alert to display the error message
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message, elementClass) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible ' +
        'fade show" role="alert">' + message + '</div>';

    $(elementClass).empty().append(errorHtml);
}

function isValidEmail(email) {
    var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
}

function isValidPhone(phone) {
    var re = /^(?:\+61|0)[2-478](?:[ -]?[0-9]){8}$/;
    return re.test(phone);
}

module.exports = {
    submit: function () {
        $('body').on('click', '#summary-apply-finance-details-submit', function (e) {
            e.preventDefault();

            var isConfigurator = !!document.querySelector('.configurator-navigation');
            var modal = $('.summary-product-finance-modal');
            var modalBody = modal.find('.modal-content');
            var form = $('.summary-apply-for-finance-form');
            var url = form.attr('action');

            var emailInput = form.find('#details-form-email');
            var emailError = form.find('#details-form-email-error');
            var phoneInput = form.find('#details-form-phone');
            var phoneError = form.find('#details-form-phone-error');

            emailError.text('');
            phoneError.text('');

            var email = emailInput.val();
            var phone = phoneInput.val();
            var hasError = false;

            if (!isValidEmail(email)) {
                emailInput.addClass('is-invalid');
                emailInput.focus();
                emailError.text('Please add valid email address').show();
                hasError = true;
                !isConfigurator && window.dataLayer.push({
                    event: "custom.form",
                    group: "Apply for finance",
                    category: "configurator",
                    action: emailError.text()
                });
            } else {
                emailInput.removeClass('is-invalid');
                emailError.hide();
            }
            if (!isValidPhone(phone)) {
                phoneInput.addClass('is-invalid');
                phoneInput.focus();
                phoneError.text('Please add valid phone number').show();
                !isConfigurator && window.dataLayer.push({
                    event: "custom.form",
                    group: "Apply for finance",
                    category: "configurator",
                    action: phoneError.text()
                });
                return
            } else {
                phoneInput.removeClass('is-invalid');
                phoneError.hide();
            }

            if (form.get(0).checkValidity()) {
                var selectedVariationId = $('#current-product').attr('data-selectedvariationid');
                var urlParams = window.location.search.substring(1);
                var formData = {
                    Title: form.find('#details-form-title').val(),
                    FirstName: form.find('#details-form-firstname').val(),
                    Surname: form.find('#details-form-lastname').val(),
                    Email: form.find('#details-form-email').val(),
                    Mobile: form.find('#details-form-phone').val(),
                    PrivacyConsent: form.find('#privacyConsentFinance').is(":checked"),
                    AddressPostcode: form.find("input[name='user-location-dealers']:checked").data('storepostcode'),
                    DealerId: form.find("input[name='user-location-dealers']:checked").val(),
                    deepLink: urlParams,
                    pid: selectedVariationId,
                    isCustomiseTab: $('#configuratorConfigure-tab').is('.active') ? true : false,
                    currentPageUrl: window.location.href,
                    metaEventId: window.applyFinanceUUID || '',
                    GACLIENTID: analyticsHelper.getGAClientId(),
                    GATRACKID: analyticsHelper.getGATrackId(),
                    GAUSERID: analyticsHelper.getGAUserId(),
                    GUID: analyticsHelper.getGAGUID()
                };

                modalBody.spinner().start();

                $.ajax({
                    url: url,
                    method: 'POST',
                    dataType: 'json',
                    data: formData,
                    success: function (data) {
                        modalBody.spinner().stop();
                        if (!data.error && data.redirectUrl) {
                            $('body').trigger('finance:formSubmitSuccess');
                            window.location.href = data.redirectUrl;
                            var selectedModels = [];
                            var inputLocation = document.getElementById('configurator-footer-location-summary')?.textContent.trim() || '';
                            var dealerName = document.getElementById('configurator-footer-dealer-name')?.textContent.trim() || '';
                            var locationParts = inputLocation.match(/^(.*)\s(\d{4,5})$/);
                            var formattedAddress = locationParts ? locationParts[1] : inputLocation;
                            var postalCode = locationParts ? locationParts[2] : '';
                            var summaryDataJSON = $('.js-save-summary').attr('data-car-summary-data');
                            var accessoriesJSONData = $('.accessory-product-data').attr('data-accessory-product-data');
                            var accessoriesData = [];
                            var ecommerceData = JSON.parse(accessoriesJSONData);
                            ecommerceData = ecommerceData.ecommerce;
                            if (ecommerceData && Array.isArray(ecommerceData.items)) {
                                for (var i = 1; i < ecommerceData.items.length; i++) {
                                    var item = ecommerceData.items[i];
                                    accessoriesData.push({
                                        accessory_id: item.item_id || '',
                                        accessory_name: item.item_name || '',
                                        accessory_category: item.item_category || '',
                                        accessory_sub_category: item.item_category2 || ''
                                    });
                                }
                            }
                            var summaryData = JSON.parse(summaryDataJSON);
                            var productData = summaryData.data.product;
                            var selectedModel = {
                                segments: productData.customProps.Body || '',
                                displayTitle: productData.productName || '',
                                title: productData.productName || '',
                                code: productData.customProps.HesCode || '',
                                sf_model: productData.customProps.Model || '',
                                sf_grade: productData.customProps.grade || '',
                                sf_door: productData.customProps.Doors || '',
                                sf_year: productData.customProps.Year || '',
                                year: productData.customProps.Year || '',
                                variants: []
                            };
                            var variantData = {
                                title: productData.variationAttributes[1].displayValue || '',
                                code: productData.customProps.HesCode || '',
                                isDefaultVariant: false,
                                transmission: productData.customProps.trans || '',
                                sfGrade: productData.customProps.grade || '',
                                sfDoor: productData.customProps.doors || '',
                                subvariants: []
                            };
                            var subVariantData = {
                                title: productData.variationAttributes[0].displayValue || '',
                                exterior_color_code: productData.customProps.color || '',
                                colorPrice: "0",
                                polkParams: "_32900_0_0_0_66_1498_1248_6.2_1_1_0_0_4_142",
                                isDefaultSubvariant: true,
                                accesories: accessoriesData ? accessoriesData : []
                            };
                            variantData.subvariants.push(subVariantData);
                            selectedModel.variants.push(variantData);
                            selectedModels.push(selectedModel);

                            !isConfigurator && window.dataLayer.push({
                                'event': 'custom.form',
                                'group': 'Apply for Finance',
                                'category': 'configurator',
                                'action': 'Complete',
                                'data': {
                                    'configurator ID': window.globalSaveuniqueCode ? window.globalSaveuniqueCode : '',
                                    'location': formattedAddress,
                                    'postcode': postalCode,
                                    'dealer': dealerName
                                },
                                models: selectedModels
                            });
                            $('.summary-product-finance-modal').modal('hide');

                        } else {
                            createErrorNotification('Please try again later', '.finance-errormsg');
                            !isConfigurator && window.dataLayer.push({
                                event: "custom.form",
                                group: "Apply for finance",
                                category: "configurator",
                                action: "Failed",
                            });
                        }
                    },
                    error: function () {
                        createErrorNotification('Please try again later', '.finance-errormsg');
                        modalBody.spinner().stop();
                        !isConfigurator && window.dataLayer.push({
                            event: "custom.form",
                            group: "Apply for finance",
                            category: "configurator",
                            action: "Failed",
                        });
                    }
                });
            }
        });
       $('#summary-product-finance-modal, #product-finance-modal-info, #customize-page-product-finance-modal-info').modal({
            backdrop: 'static',
            keyboard: false,
            show: false
        });

        $('.summary-apply-for-finance-cta').on('click', (e) => {
            e.preventDefault();
           $('#product-finance-modal-info').modal('hide');
           $('#customize-page-product-finance-modal-info').modal('hide');
            $('#summary-product-finance-modal').modal('show');
            var $summaryFinanceDealers = $('#summary-location-dealers-for-finance');
            $.ajax({
                url: $summaryFinanceDealers.data('action'),
                type: 'get',
                dataType: 'json',
                data: {
                    requestFrom: 'summary finance form'
                },
                success: function (data) {
                    var dealersListHtml = data.innerHTML || 'Unable to get Dealers List';
                    $summaryFinanceDealers.html(dealersListHtml);
                }
            });
        });

        $('.summary-apply-for-finance-cta-info-customize, .summary-apply-for-finance-cta-info, .js-open-apply-for-finance').on('click', function (e) {
            e.preventDefault();
            var $flyout = $('.configurator-modal');
            var $navApplyFinance = $('.configurator-modal .list-group-item-action[data-view="apply-for-finance"]').first();

            if ($flyout.length && $navApplyFinance.length) {
                if (!$flyout.hasClass('show')) {
                    $flyout.modal('show');
                }
                $navApplyFinance[0].click();
                return;
            }
        });

       $('#product-finance-modal-info, #summary-product-finance-modal, #customize-page-product-finance-modal-info').on('show.bs.modal', function () {
            $(this).addClass('modal-stack');
            setTimeout(function () {
                $('.modal-backdrop').last().addClass('stack');
            }, 0);
        });

        $(document).on('hidden.bs.modal', '.modal', function (){
            if ($('.modal.show').length) $('body').addClass('modal-open');
        });

        $('#summary-product-finance-modal, #product-finance-modal-info, #customize-page-product-finance-modal-info').appendTo('body');
    }

};
